import { defineNuxtPlugin } from '#app/nuxt'
import { LazyCatalogOrderForm, LazyCollapsableText, LazyContactForm, LazyFoldableText, LazyGoldnerClubEntryPageActions, LazyGoldnerClubSignInForm, LazyGoldnerClubSubscribe, LazyNewsletterSubscription, LazyNewsletterSubscriptionNew, LazyNewsletterUnsubscribe, LazyNewsletterUnsubscribeTransaction, LazyOrderCancellationRequestForm, LazyParagraph, LazyRecommendations, LazyScreenReaderOnlyText, LazyAdvantagePage, LazyAdvantageProduct, LazyAdvantageProductGroup, LazyCampaignTeaser, LazyCategoryTeaser, LazyCtaButton, LazyCmsText, LazyGridFixSize, LazyHeroBanner, LazyHeroBannerSlider, LazyIconSlider, LazyIconSliderSlide, LazyImageText, LazyImageTextGrid, LazyContentPage, LazyContentPageHeader, LazyListingPage, LazyPage, LazyBlogOverview, LazyCMSLink, LazyRichTextLink, LazyScrollableLinkList, LazyCmsImage, LazyInteractableImage, LazyInteractableVideo, LazyVimeoVideo, LazyNavigationItem, LazyProduct, LazyProductSlider, LazySlideShow, LazyStage, LazyStageButton, LazyStageSlide, LazyStoryPills, LazyBannerValantic, LazyAccordion, LazyAccordionEntry, LazyContentFragment, LazyContentFragmentsPage, LazyGoogleForm, LazyLookbook, LazyNewsletterRegisterWidget, LazySizeTable, LazyStory, LazyUSP, LazyCategoryTeaserGrid, LazyFeature, LazyFeatureList, LazyColumn, LazyGrid, LazyConstructionPage, LazyListingDisruptor, LazyAssetImage, LazyVideo, LazyYouTubeVideo, LazyStageHeadline, LazyStageKicker, LazyIconHearth, LazyIconLogin, LazyIconShoppingCartMobileNav, LazyIconShoppingCart, LazyIconAj, LazyIconArrowDown, LazyIconArrowLeft, LazyIconArrowRightBlackM, LazyIconArrowRightSmall, LazyIconArrowRightWhiteM, LazyIconArrowRight, LazyIconArrowTrueDown, LazyIconArrowUp, LazyIconBack, LazyIconBasket, LazyIconBurger, LazyIconCareBleach, LazyIconCareBleachNoBleach, LazyIconCareBleachNonChlorineBleach, LazyIconCareCleanFOnlyDelicate, LazyIconCareCleanFOnly, LazyIconCareCleanNoDryClean, LazyIconCareCleanNoWetClean, LazyIconCareCleanPOnlyDelicate, LazyIconCareCleanPOnly, LazyIconCareCleanWetCleanDelicate, LazyIconCareCleanWetCleanVeryDelicate, LazyIconCareCleanWetClean, LazyIconCareDryNoTumbleDry, LazyIconCareDryTumbleDryLowTemp, LazyIconCareDryTumbleDryMediumTemp, LazyIconCareIronHighTemp, LazyIconCareIronLowTemp, LazyIconCareIronMediumTemp, LazyIconCareIronNoIron, LazyIconCareWash30DegreeDelicate, LazyIconCareWash30DegreeVeryDelicate, LazyIconCareWash30Degree, LazyIconCareWash40DegreeDelicate, LazyIconCareWash40DegreeVeryDelicate, LazyIconCareWash40Degree, LazyIconCareWash60DegreeDelicate, LazyIconCareWash60Degree, LazyIconCareWash95Degree, LazyIconCareWashHandWash, LazyIconCareWashNoWash, LazyIconCheckGreen, LazyIconCheck, LazyIconCheckboxAct, LazyIconCheckboxDisAct, LazyIconCheckboxDis, LazyIconCheckbox, LazyIconCheckmark, LazyIconCircleGreen, LazyIconCloseS, LazyIconClose, LazyIconCoatHanger, LazyIconCollect, LazyIconCross, LazyIconDate, LazyIconDelivery, LazyIconDifDeliv, LazyIconDiscountBagMobile, LazyIconDoc, LazyIconDown, LazyIconDownload, LazyIconDropdown, LazyIconEmptyCart, LazyIconErrorX, LazyIconError, LazyIconEyeAbleIcon, LazyIconEyeCrossed, LazyIconEye, LazyIconEyeable, LazyIconFacebook, LazyIconFb, LazyIconFilter, LazyIconFlagMustHaves, LazyIconFooterLogo, LazyIconFooterAnniversaryLogoDe, LazyIconFooterAnniversaryLogoFi, LazyIconFooterAnniversaryLogoFr, LazyIconFooterAnniversaryLogoNl, LazyIconFooterCarrierBpost, LazyIconFooterCarrierBring, LazyIconFooterCarrierColissimo, LazyIconFooterCarrierDhl, LazyIconFooterCarrierLaposte, LazyIconFooterCarrierPostAt, LazyIconFooterCarrierPostCh, LazyIconFooterCarrierPostNl, LazyIconFooterCarrierPosti, LazyIconFooterPaymentBancontact, LazyIconFooterPaymentCartesBancaires, LazyIconFooterPaymentIdeal, LazyIconFooterPaymentMastercard, LazyIconFooterPaymentPaypalInstant, LazyIconFooterPaymentVisa, LazyIconFooterSecurityFevad, LazyIconFooterSecurityHandelsverbandAt, LazyIconFooterSecurityRpj, LazyIconFooterSecuritySv, LazyIconFooterSecuritySwissOnline, LazyIconFooterSecurityThuiswinkel, LazyIconFooterSecurityTrustEcommerceEurope, LazyIconFreeAdviceMobile, LazyIconFreeAdvice, LazyIconFreeReturnsMobile, LazyIconFreeReturns, LazyIconFunctionIcons100prozentAlpaka, LazyIconFunctionIcons100prozentBaumwolle, LazyIconFunctionIcons100prozentKaschmir, LazyIconFunctionIcons100prozentMerino, LazyIconFunctionIcons100prozentWolle, LazyIconFunctionIcons2WegeReissverschluss, LazyIconFunctionIcons2WegeStretch, LazyIconFunctionIcons3In1, LazyIconFunctionIcons4WegeStretch, LazyIconFunctionIconsAllwettertauglich, LazyIconFunctionIconsAtmungsaktiv, LazyIconFunctionIconsAuchFuerProthesenGeeignet, LazyIconFunctionIconsBeiLeichterInkontinenz, LazyIconFunctionIconsBeiMittlererInkontinenz, LazyIconFunctionIconsBeiStarkerInkontinenz, LazyIconFunctionIconsBuegelfrei, LazyIconFunctionIconsBuegellos, LazyIconFunctionIconsChlorresistent, LazyIconFunctionIconsDefault, LazyIconFunctionIconsDoppelpack, LazyIconFunctionIconsDoppelverschluss, LazyIconFunctionIconsEchtleder, LazyIconFunctionIconsEmpfehlenswertBeiLangemSitzen, LazyIconFunctionIconsFederleicht, LazyIconFunctionIconsFeuchtigkeitsregulierend, LazyIconFunctionIconsFormbestaendig, LazyIconFunctionIconsFormbund, LazyIconFunctionIconsFuerJedeJahreszeit, LazyIconFunctionIconsFussspitzeHandkettelt, LazyIconFunctionIconsGefuettertePads, LazyIconFunctionIconsHerausnehmbarePads, LazyIconFunctionIconsKapuzeAbtrennbar, LazyIconFunctionIconsKomfortTraegerWeiteTraeger, LazyIconFunctionIconsKrempelbar, LazyIconFunctionIconsLeichtWaermend, LazyIconFunctionIconsMehrfachpack, LazyIconFunctionIconsMinimizer, LazyIconFunctionIconsMitAlpaka, LazyIconFunctionIconsMitBaumwolle, LazyIconFunctionIconsMitBiobaumwolle, LazyIconFunctionIconsMitBuegel, LazyIconFunctionIconsMitKaschmir, LazyIconFunctionIconsMitMerino, LazyIconFunctionIconsMitRecyceltemRohstoff, LazyIconFunctionIconsMitSchurwolle, LazyIconFunctionIconsMitWolle, LazyIconFunctionIconsModal, LazyIconFunctionIconsNachhaltig, LazyIconFunctionIconsNahtlos, LazyIconFunctionIconsNichtSichtbar, LazyIconFunctionIconsPflegeleicht, LazyIconFunctionIconsReflektierend, LazyIconFunctionIconsRundumDehnbund, LazyIconFunctionIconsSchnelltrocknend, LazyIconFunctionIconsShaping, LazyIconFunctionIconsSoftTouch, LazyIconFunctionIconsStarkWaermend, LazyIconFunctionIconsStuetzendUndDurchblutungsfoerdernd, LazyIconFunctionIconsTeildehnbund, LazyIconFunctionIconsThermo, LazyIconFunctionIconsTrocknergeeignet, LazyIconFunctionIconsTwinset, LazyIconFunctionIconsUvSchutz, LazyIconFunctionIconsVerdeckterReissverschluss, LazyIconFunctionIconsVerstaerkteBauchpartie, LazyIconFunctionIconsVerstellbareTraeger, LazyIconFunctionIconsViskose, LazyIconFunctionIconsVorderverschluss, LazyIconFunctionIconsWaermend, LazyIconFunctionIconsWaermeregulierend, LazyIconFunctionIconsWaschmaschinengeeignet, LazyIconFunctionIconsWasserAbweisend, LazyIconFunctionIconsWebshopWeitenF, LazyIconFunctionIconsWebshopWeitenG, LazyIconFunctionIconsWebshopWeitenH, LazyIconFunctionIconsWebshopWeitenK, LazyIconFunctionIconsWebshopWeitenM, LazyIconFunctionIconsWendejacke, LazyIconFunctionIconsWindabweisend, LazyIconFunctionIconsZusaetzlicheTaschen, LazyIconFunctionIconsZweiteilerV1, LazyIconFunctionIconsZweiteilerV2, LazyIconGerman, LazyIconGlobe, LazyIconGoldnerClubLogo, LazyIconGoogleMaps, LazyIconHeartFull, LazyIconHeartMobileNav, LazyIconHeart, LazyIconInfo, LazyIconInformation, LazyIconInstagram, LazyIconInvoice, LazyIconLeft, LazyIconLinkedin, LazyIconLoginMobileNav, LazyIconMail, LazyIconMeasuringTape, LazyIconMinus, LazyIconOrder, LazyIconPaginationArrowLeft, LazyIconPaginationArrowRight, LazyIconPayback, LazyIconPaymentProtection, LazyIconPaymentDinersclub, LazyIconPaymentDiscover, LazyIconPaymentIdeal, LazyIconPaymentKlarna, LazyIconPaymentLastschrift, LazyIconPaymentMastercard, LazyIconPaymentPaypal, LazyIconPaymentRatepay, LazyIconPaymentSofort, LazyIconPaymentVisa, LazyIconPen, LazyIconPhone, LazyIconPinterest, LazyIconPlus, LazyIconPurchaseOnInvoiceMobile, LazyIconPurchaseOnInvoice, LazyIconRadioOff, LazyIconRadioOn, LazyIconReset, LazyIconReturn, LazyIconRight, LazyIconSameDeliv, LazyIconSearch, LazyIconShoppingCartFill, LazyIconSince1991Mobile, LazyIconSince1991, LazyIconSpinner, LazyIconSsl, LazyIconSuccess, LazyIconTrash, LazyIconUiArrowLeft, LazyIconUiArrowRight, LazyIconUiBack, LazyIconUiBacktotop, LazyIconUiBasket, LazyIconUiBurger, LazyIconUiCheckmark, LazyIconUiChevron, LazyIconUiClose, LazyIconUiCollapse, LazyIconUiDropdown, LazyIconUiExpand, LazyIconUiList, LazyIconUiMinus, LazyIconUiPlus, LazyIconUiSearch, LazyIconUiSocialFacebook, LazyIconUiSocialInstagram, LazyIconUiSocialPinterest, LazyIconUiSocialYoutube, LazyIconUiWishlistFilled, LazyIconUiWishlist, LazyIconUiZoomIn, LazyIconUiZoomOut, LazyIconUp, LazyIconUpdownGray, LazyIconUpdown, LazyIconUserSecondary, LazyIconUsers, LazyIconXCircle, LazyIconYoutube } from '#components'
const lazyGlobalComponents = [
  ["CatalogOrderForm", LazyCatalogOrderForm],
["CollapsableText", LazyCollapsableText],
["ContactForm", LazyContactForm],
["FoldableText", LazyFoldableText],
["GoldnerClubEntryPageActions", LazyGoldnerClubEntryPageActions],
["GoldnerClubSignInForm", LazyGoldnerClubSignInForm],
["GoldnerClubSubscribe", LazyGoldnerClubSubscribe],
["NewsletterSubscription", LazyNewsletterSubscription],
["NewsletterSubscriptionNew", LazyNewsletterSubscriptionNew],
["NewsletterUnsubscribe", LazyNewsletterUnsubscribe],
["NewsletterUnsubscribeTransaction", LazyNewsletterUnsubscribeTransaction],
["OrderCancellationRequestForm", LazyOrderCancellationRequestForm],
["Paragraph", LazyParagraph],
["Recommendations", LazyRecommendations],
["ScreenReaderOnlyText", LazyScreenReaderOnlyText],
["AdvantagePage", LazyAdvantagePage],
["AdvantageProduct", LazyAdvantageProduct],
["AdvantageProductGroup", LazyAdvantageProductGroup],
["CampaignTeaser", LazyCampaignTeaser],
["CategoryTeaser", LazyCategoryTeaser],
["CtaButton", LazyCtaButton],
["CmsText", LazyCmsText],
["GridFixSize", LazyGridFixSize],
["HeroBanner", LazyHeroBanner],
["HeroBannerSlider", LazyHeroBannerSlider],
["IconSlider", LazyIconSlider],
["IconSliderSlide", LazyIconSliderSlide],
["ImageText", LazyImageText],
["ImageTextGrid", LazyImageTextGrid],
["ContentPage", LazyContentPage],
["ContentPageHeader", LazyContentPageHeader],
["ListingPage", LazyListingPage],
["Page", LazyPage],
["BlogOverview", LazyBlogOverview],
["CMSLink", LazyCMSLink],
["RichTextLink", LazyRichTextLink],
["ScrollableLinkList", LazyScrollableLinkList],
["CmsImage", LazyCmsImage],
["InteractableImage", LazyInteractableImage],
["InteractableVideo", LazyInteractableVideo],
["VimeoVideo", LazyVimeoVideo],
["NavigationItem", LazyNavigationItem],
["Product", LazyProduct],
["ProductSlider", LazyProductSlider],
["SlideShow", LazySlideShow],
["Stage", LazyStage],
["StageButton", LazyStageButton],
["StageSlide", LazyStageSlide],
["StoryPills", LazyStoryPills],
["BannerValantic", LazyBannerValantic],
["Accordion", LazyAccordion],
["AccordionEntry", LazyAccordionEntry],
["ContentFragment", LazyContentFragment],
["ContentFragmentsPage", LazyContentFragmentsPage],
["GoogleForm", LazyGoogleForm],
["Lookbook", LazyLookbook],
["NewsletterRegisterWidget", LazyNewsletterRegisterWidget],
["SizeTable", LazySizeTable],
["Story", LazyStory],
["USP", LazyUSP],
["CategoryTeaserGrid", LazyCategoryTeaserGrid],
["Feature", LazyFeature],
["FeatureList", LazyFeatureList],
["Column", LazyColumn],
["Grid", LazyGrid],
["ConstructionPage", LazyConstructionPage],
["ListingDisruptor", LazyListingDisruptor],
["AssetImage", LazyAssetImage],
["Video", LazyVideo],
["YouTubeVideo", LazyYouTubeVideo],
["StageHeadline", LazyStageHeadline],
["StageKicker", LazyStageKicker],
["IconHearth", LazyIconHearth],
["IconLogin", LazyIconLogin],
["IconShoppingCartMobileNav", LazyIconShoppingCartMobileNav],
["IconShoppingCart", LazyIconShoppingCart],
["IconAj", LazyIconAj],
["IconArrowDown", LazyIconArrowDown],
["IconArrowLeft", LazyIconArrowLeft],
["IconArrowRightBlackM", LazyIconArrowRightBlackM],
["IconArrowRightSmall", LazyIconArrowRightSmall],
["IconArrowRightWhiteM", LazyIconArrowRightWhiteM],
["IconArrowRight", LazyIconArrowRight],
["IconArrowTrueDown", LazyIconArrowTrueDown],
["IconArrowUp", LazyIconArrowUp],
["IconBack", LazyIconBack],
["IconBasket", LazyIconBasket],
["IconBurger", LazyIconBurger],
["IconCareBleach", LazyIconCareBleach],
["IconCareBleachNoBleach", LazyIconCareBleachNoBleach],
["IconCareBleachNonChlorineBleach", LazyIconCareBleachNonChlorineBleach],
["IconCareCleanFOnlyDelicate", LazyIconCareCleanFOnlyDelicate],
["IconCareCleanFOnly", LazyIconCareCleanFOnly],
["IconCareCleanNoDryClean", LazyIconCareCleanNoDryClean],
["IconCareCleanNoWetClean", LazyIconCareCleanNoWetClean],
["IconCareCleanPOnlyDelicate", LazyIconCareCleanPOnlyDelicate],
["IconCareCleanPOnly", LazyIconCareCleanPOnly],
["IconCareCleanWetCleanDelicate", LazyIconCareCleanWetCleanDelicate],
["IconCareCleanWetCleanVeryDelicate", LazyIconCareCleanWetCleanVeryDelicate],
["IconCareCleanWetClean", LazyIconCareCleanWetClean],
["IconCareDryNoTumbleDry", LazyIconCareDryNoTumbleDry],
["IconCareDryTumbleDryLowTemp", LazyIconCareDryTumbleDryLowTemp],
["IconCareDryTumbleDryMediumTemp", LazyIconCareDryTumbleDryMediumTemp],
["IconCareIronHighTemp", LazyIconCareIronHighTemp],
["IconCareIronLowTemp", LazyIconCareIronLowTemp],
["IconCareIronMediumTemp", LazyIconCareIronMediumTemp],
["IconCareIronNoIron", LazyIconCareIronNoIron],
["IconCareWash30DegreeDelicate", LazyIconCareWash30DegreeDelicate],
["IconCareWash30DegreeVeryDelicate", LazyIconCareWash30DegreeVeryDelicate],
["IconCareWash30Degree", LazyIconCareWash30Degree],
["IconCareWash40DegreeDelicate", LazyIconCareWash40DegreeDelicate],
["IconCareWash40DegreeVeryDelicate", LazyIconCareWash40DegreeVeryDelicate],
["IconCareWash40Degree", LazyIconCareWash40Degree],
["IconCareWash60DegreeDelicate", LazyIconCareWash60DegreeDelicate],
["IconCareWash60Degree", LazyIconCareWash60Degree],
["IconCareWash95Degree", LazyIconCareWash95Degree],
["IconCareWashHandWash", LazyIconCareWashHandWash],
["IconCareWashNoWash", LazyIconCareWashNoWash],
["IconCheckGreen", LazyIconCheckGreen],
["IconCheck", LazyIconCheck],
["IconCheckboxAct", LazyIconCheckboxAct],
["IconCheckboxDisAct", LazyIconCheckboxDisAct],
["IconCheckboxDis", LazyIconCheckboxDis],
["IconCheckbox", LazyIconCheckbox],
["IconCheckmark", LazyIconCheckmark],
["IconCircleGreen", LazyIconCircleGreen],
["IconCloseS", LazyIconCloseS],
["IconClose", LazyIconClose],
["IconCoatHanger", LazyIconCoatHanger],
["IconCollect", LazyIconCollect],
["IconCross", LazyIconCross],
["IconDate", LazyIconDate],
["IconDelivery", LazyIconDelivery],
["IconDifDeliv", LazyIconDifDeliv],
["IconDiscountBagMobile", LazyIconDiscountBagMobile],
["IconDoc", LazyIconDoc],
["IconDown", LazyIconDown],
["IconDownload", LazyIconDownload],
["IconDropdown", LazyIconDropdown],
["IconEmptyCart", LazyIconEmptyCart],
["IconErrorX", LazyIconErrorX],
["IconError", LazyIconError],
["IconEyeAbleIcon", LazyIconEyeAbleIcon],
["IconEyeCrossed", LazyIconEyeCrossed],
["IconEye", LazyIconEye],
["IconEyeable", LazyIconEyeable],
["IconFacebook", LazyIconFacebook],
["IconFb", LazyIconFb],
["IconFilter", LazyIconFilter],
["IconFlagMustHaves", LazyIconFlagMustHaves],
["IconFooterLogo", LazyIconFooterLogo],
["IconFooterAnniversaryLogoDe", LazyIconFooterAnniversaryLogoDe],
["IconFooterAnniversaryLogoFi", LazyIconFooterAnniversaryLogoFi],
["IconFooterAnniversaryLogoFr", LazyIconFooterAnniversaryLogoFr],
["IconFooterAnniversaryLogoNl", LazyIconFooterAnniversaryLogoNl],
["IconFooterCarrierBpost", LazyIconFooterCarrierBpost],
["IconFooterCarrierBring", LazyIconFooterCarrierBring],
["IconFooterCarrierColissimo", LazyIconFooterCarrierColissimo],
["IconFooterCarrierDhl", LazyIconFooterCarrierDhl],
["IconFooterCarrierLaposte", LazyIconFooterCarrierLaposte],
["IconFooterCarrierPostAt", LazyIconFooterCarrierPostAt],
["IconFooterCarrierPostCh", LazyIconFooterCarrierPostCh],
["IconFooterCarrierPostNl", LazyIconFooterCarrierPostNl],
["IconFooterCarrierPosti", LazyIconFooterCarrierPosti],
["IconFooterPaymentBancontact", LazyIconFooterPaymentBancontact],
["IconFooterPaymentCartesBancaires", LazyIconFooterPaymentCartesBancaires],
["IconFooterPaymentIdeal", LazyIconFooterPaymentIdeal],
["IconFooterPaymentMastercard", LazyIconFooterPaymentMastercard],
["IconFooterPaymentPaypalInstant", LazyIconFooterPaymentPaypalInstant],
["IconFooterPaymentVisa", LazyIconFooterPaymentVisa],
["IconFooterSecurityFevad", LazyIconFooterSecurityFevad],
["IconFooterSecurityHandelsverbandAt", LazyIconFooterSecurityHandelsverbandAt],
["IconFooterSecurityRpj", LazyIconFooterSecurityRpj],
["IconFooterSecuritySv", LazyIconFooterSecuritySv],
["IconFooterSecuritySwissOnline", LazyIconFooterSecuritySwissOnline],
["IconFooterSecurityThuiswinkel", LazyIconFooterSecurityThuiswinkel],
["IconFooterSecurityTrustEcommerceEurope", LazyIconFooterSecurityTrustEcommerceEurope],
["IconFreeAdviceMobile", LazyIconFreeAdviceMobile],
["IconFreeAdvice", LazyIconFreeAdvice],
["IconFreeReturnsMobile", LazyIconFreeReturnsMobile],
["IconFreeReturns", LazyIconFreeReturns],
["IconFunctionIcons100prozentAlpaka", LazyIconFunctionIcons100prozentAlpaka],
["IconFunctionIcons100prozentBaumwolle", LazyIconFunctionIcons100prozentBaumwolle],
["IconFunctionIcons100prozentKaschmir", LazyIconFunctionIcons100prozentKaschmir],
["IconFunctionIcons100prozentMerino", LazyIconFunctionIcons100prozentMerino],
["IconFunctionIcons100prozentWolle", LazyIconFunctionIcons100prozentWolle],
["IconFunctionIcons2WegeReissverschluss", LazyIconFunctionIcons2WegeReissverschluss],
["IconFunctionIcons2WegeStretch", LazyIconFunctionIcons2WegeStretch],
["IconFunctionIcons3In1", LazyIconFunctionIcons3In1],
["IconFunctionIcons4WegeStretch", LazyIconFunctionIcons4WegeStretch],
["IconFunctionIconsAllwettertauglich", LazyIconFunctionIconsAllwettertauglich],
["IconFunctionIconsAtmungsaktiv", LazyIconFunctionIconsAtmungsaktiv],
["IconFunctionIconsAuchFuerProthesenGeeignet", LazyIconFunctionIconsAuchFuerProthesenGeeignet],
["IconFunctionIconsBeiLeichterInkontinenz", LazyIconFunctionIconsBeiLeichterInkontinenz],
["IconFunctionIconsBeiMittlererInkontinenz", LazyIconFunctionIconsBeiMittlererInkontinenz],
["IconFunctionIconsBeiStarkerInkontinenz", LazyIconFunctionIconsBeiStarkerInkontinenz],
["IconFunctionIconsBuegelfrei", LazyIconFunctionIconsBuegelfrei],
["IconFunctionIconsBuegellos", LazyIconFunctionIconsBuegellos],
["IconFunctionIconsChlorresistent", LazyIconFunctionIconsChlorresistent],
["IconFunctionIconsDefault", LazyIconFunctionIconsDefault],
["IconFunctionIconsDoppelpack", LazyIconFunctionIconsDoppelpack],
["IconFunctionIconsDoppelverschluss", LazyIconFunctionIconsDoppelverschluss],
["IconFunctionIconsEchtleder", LazyIconFunctionIconsEchtleder],
["IconFunctionIconsEmpfehlenswertBeiLangemSitzen", LazyIconFunctionIconsEmpfehlenswertBeiLangemSitzen],
["IconFunctionIconsFederleicht", LazyIconFunctionIconsFederleicht],
["IconFunctionIconsFeuchtigkeitsregulierend", LazyIconFunctionIconsFeuchtigkeitsregulierend],
["IconFunctionIconsFormbestaendig", LazyIconFunctionIconsFormbestaendig],
["IconFunctionIconsFormbund", LazyIconFunctionIconsFormbund],
["IconFunctionIconsFuerJedeJahreszeit", LazyIconFunctionIconsFuerJedeJahreszeit],
["IconFunctionIconsFussspitzeHandkettelt", LazyIconFunctionIconsFussspitzeHandkettelt],
["IconFunctionIconsGefuettertePads", LazyIconFunctionIconsGefuettertePads],
["IconFunctionIconsHerausnehmbarePads", LazyIconFunctionIconsHerausnehmbarePads],
["IconFunctionIconsKapuzeAbtrennbar", LazyIconFunctionIconsKapuzeAbtrennbar],
["IconFunctionIconsKomfortTraegerWeiteTraeger", LazyIconFunctionIconsKomfortTraegerWeiteTraeger],
["IconFunctionIconsKrempelbar", LazyIconFunctionIconsKrempelbar],
["IconFunctionIconsLeichtWaermend", LazyIconFunctionIconsLeichtWaermend],
["IconFunctionIconsMehrfachpack", LazyIconFunctionIconsMehrfachpack],
["IconFunctionIconsMinimizer", LazyIconFunctionIconsMinimizer],
["IconFunctionIconsMitAlpaka", LazyIconFunctionIconsMitAlpaka],
["IconFunctionIconsMitBaumwolle", LazyIconFunctionIconsMitBaumwolle],
["IconFunctionIconsMitBiobaumwolle", LazyIconFunctionIconsMitBiobaumwolle],
["IconFunctionIconsMitBuegel", LazyIconFunctionIconsMitBuegel],
["IconFunctionIconsMitKaschmir", LazyIconFunctionIconsMitKaschmir],
["IconFunctionIconsMitMerino", LazyIconFunctionIconsMitMerino],
["IconFunctionIconsMitRecyceltemRohstoff", LazyIconFunctionIconsMitRecyceltemRohstoff],
["IconFunctionIconsMitSchurwolle", LazyIconFunctionIconsMitSchurwolle],
["IconFunctionIconsMitWolle", LazyIconFunctionIconsMitWolle],
["IconFunctionIconsModal", LazyIconFunctionIconsModal],
["IconFunctionIconsNachhaltig", LazyIconFunctionIconsNachhaltig],
["IconFunctionIconsNahtlos", LazyIconFunctionIconsNahtlos],
["IconFunctionIconsNichtSichtbar", LazyIconFunctionIconsNichtSichtbar],
["IconFunctionIconsPflegeleicht", LazyIconFunctionIconsPflegeleicht],
["IconFunctionIconsReflektierend", LazyIconFunctionIconsReflektierend],
["IconFunctionIconsRundumDehnbund", LazyIconFunctionIconsRundumDehnbund],
["IconFunctionIconsSchnelltrocknend", LazyIconFunctionIconsSchnelltrocknend],
["IconFunctionIconsShaping", LazyIconFunctionIconsShaping],
["IconFunctionIconsSoftTouch", LazyIconFunctionIconsSoftTouch],
["IconFunctionIconsStarkWaermend", LazyIconFunctionIconsStarkWaermend],
["IconFunctionIconsStuetzendUndDurchblutungsfoerdernd", LazyIconFunctionIconsStuetzendUndDurchblutungsfoerdernd],
["IconFunctionIconsTeildehnbund", LazyIconFunctionIconsTeildehnbund],
["IconFunctionIconsThermo", LazyIconFunctionIconsThermo],
["IconFunctionIconsTrocknergeeignet", LazyIconFunctionIconsTrocknergeeignet],
["IconFunctionIconsTwinset", LazyIconFunctionIconsTwinset],
["IconFunctionIconsUvSchutz", LazyIconFunctionIconsUvSchutz],
["IconFunctionIconsVerdeckterReissverschluss", LazyIconFunctionIconsVerdeckterReissverschluss],
["IconFunctionIconsVerstaerkteBauchpartie", LazyIconFunctionIconsVerstaerkteBauchpartie],
["IconFunctionIconsVerstellbareTraeger", LazyIconFunctionIconsVerstellbareTraeger],
["IconFunctionIconsViskose", LazyIconFunctionIconsViskose],
["IconFunctionIconsVorderverschluss", LazyIconFunctionIconsVorderverschluss],
["IconFunctionIconsWaermend", LazyIconFunctionIconsWaermend],
["IconFunctionIconsWaermeregulierend", LazyIconFunctionIconsWaermeregulierend],
["IconFunctionIconsWaschmaschinengeeignet", LazyIconFunctionIconsWaschmaschinengeeignet],
["IconFunctionIconsWasserAbweisend", LazyIconFunctionIconsWasserAbweisend],
["IconFunctionIconsWebshopWeitenF", LazyIconFunctionIconsWebshopWeitenF],
["IconFunctionIconsWebshopWeitenG", LazyIconFunctionIconsWebshopWeitenG],
["IconFunctionIconsWebshopWeitenH", LazyIconFunctionIconsWebshopWeitenH],
["IconFunctionIconsWebshopWeitenK", LazyIconFunctionIconsWebshopWeitenK],
["IconFunctionIconsWebshopWeitenM", LazyIconFunctionIconsWebshopWeitenM],
["IconFunctionIconsWendejacke", LazyIconFunctionIconsWendejacke],
["IconFunctionIconsWindabweisend", LazyIconFunctionIconsWindabweisend],
["IconFunctionIconsZusaetzlicheTaschen", LazyIconFunctionIconsZusaetzlicheTaschen],
["IconFunctionIconsZweiteilerV1", LazyIconFunctionIconsZweiteilerV1],
["IconFunctionIconsZweiteilerV2", LazyIconFunctionIconsZweiteilerV2],
["IconGerman", LazyIconGerman],
["IconGlobe", LazyIconGlobe],
["IconGoldnerClubLogo", LazyIconGoldnerClubLogo],
["IconGoogleMaps", LazyIconGoogleMaps],
["IconHeartFull", LazyIconHeartFull],
["IconHeartMobileNav", LazyIconHeartMobileNav],
["IconHeart", LazyIconHeart],
["IconInfo", LazyIconInfo],
["IconInformation", LazyIconInformation],
["IconInstagram", LazyIconInstagram],
["IconInvoice", LazyIconInvoice],
["IconLeft", LazyIconLeft],
["IconLinkedin", LazyIconLinkedin],
["IconLoginMobileNav", LazyIconLoginMobileNav],
["IconMail", LazyIconMail],
["IconMeasuringTape", LazyIconMeasuringTape],
["IconMinus", LazyIconMinus],
["IconOrder", LazyIconOrder],
["IconPaginationArrowLeft", LazyIconPaginationArrowLeft],
["IconPaginationArrowRight", LazyIconPaginationArrowRight],
["IconPayback", LazyIconPayback],
["IconPaymentProtection", LazyIconPaymentProtection],
["IconPaymentDinersclub", LazyIconPaymentDinersclub],
["IconPaymentDiscover", LazyIconPaymentDiscover],
["IconPaymentIdeal", LazyIconPaymentIdeal],
["IconPaymentKlarna", LazyIconPaymentKlarna],
["IconPaymentLastschrift", LazyIconPaymentLastschrift],
["IconPaymentMastercard", LazyIconPaymentMastercard],
["IconPaymentPaypal", LazyIconPaymentPaypal],
["IconPaymentRatepay", LazyIconPaymentRatepay],
["IconPaymentSofort", LazyIconPaymentSofort],
["IconPaymentVisa", LazyIconPaymentVisa],
["IconPen", LazyIconPen],
["IconPhone", LazyIconPhone],
["IconPinterest", LazyIconPinterest],
["IconPlus", LazyIconPlus],
["IconPurchaseOnInvoiceMobile", LazyIconPurchaseOnInvoiceMobile],
["IconPurchaseOnInvoice", LazyIconPurchaseOnInvoice],
["IconRadioOff", LazyIconRadioOff],
["IconRadioOn", LazyIconRadioOn],
["IconReset", LazyIconReset],
["IconReturn", LazyIconReturn],
["IconRight", LazyIconRight],
["IconSameDeliv", LazyIconSameDeliv],
["IconSearch", LazyIconSearch],
["IconShoppingCartFill", LazyIconShoppingCartFill],
["IconSince1991Mobile", LazyIconSince1991Mobile],
["IconSince1991", LazyIconSince1991],
["IconSpinner", LazyIconSpinner],
["IconSsl", LazyIconSsl],
["IconSuccess", LazyIconSuccess],
["IconTrash", LazyIconTrash],
["IconUiArrowLeft", LazyIconUiArrowLeft],
["IconUiArrowRight", LazyIconUiArrowRight],
["IconUiBack", LazyIconUiBack],
["IconUiBacktotop", LazyIconUiBacktotop],
["IconUiBasket", LazyIconUiBasket],
["IconUiBurger", LazyIconUiBurger],
["IconUiCheckmark", LazyIconUiCheckmark],
["IconUiChevron", LazyIconUiChevron],
["IconUiClose", LazyIconUiClose],
["IconUiCollapse", LazyIconUiCollapse],
["IconUiDropdown", LazyIconUiDropdown],
["IconUiExpand", LazyIconUiExpand],
["IconUiList", LazyIconUiList],
["IconUiMinus", LazyIconUiMinus],
["IconUiPlus", LazyIconUiPlus],
["IconUiSearch", LazyIconUiSearch],
["IconUiSocialFacebook", LazyIconUiSocialFacebook],
["IconUiSocialInstagram", LazyIconUiSocialInstagram],
["IconUiSocialPinterest", LazyIconUiSocialPinterest],
["IconUiSocialYoutube", LazyIconUiSocialYoutube],
["IconUiWishlistFilled", LazyIconUiWishlistFilled],
["IconUiWishlist", LazyIconUiWishlist],
["IconUiZoomIn", LazyIconUiZoomIn],
["IconUiZoomOut", LazyIconUiZoomOut],
["IconUp", LazyIconUp],
["IconUpdownGray", LazyIconUpdownGray],
["IconUpdown", LazyIconUpdown],
["IconUserSecondary", LazyIconUserSecondary],
["IconUsers", LazyIconUsers],
["IconXCircle", LazyIconXCircle],
["IconYoutube", LazyIconYoutube],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
